export default __webpack_public_path__ + "static/media/clipBanner.fe41a087.png";